module.exports = __webpack_public_path__ + "img/book.da6b26ad.png";